
import { Component, Prop, Vue } from 'vue-property-decorator'
import Close from '~/components/common/ctrls/CloseCrossCtrl.vue'
import Button from '~/components/common/buttons/DashboardButton.vue'

@Component({
  name: 'MaintenanceModal',
  components: {
    Button,
    Close
  }
})
export default class ReactivateProModal extends Vue {
  @Prop({ type: Function, default: () => {} }) leftBtnClick: () => Promise<any>
  @Prop({ type: String, default: '' }) openedFrom: string

  mounted() {
    this.mixpanelTrack(this.$mixpanel.events.REACTIVATE_PRO_MODAL_VIEW)
    this.handleDropdownUserPanelZIndex()
  }

  handleDropdownUserPanelZIndex() {
    const dropdownUserPanel = document.getElementsByClassName('drop-down-base')[0]
    if (dropdownUserPanel && dropdownUserPanel.classList.contains('drop-down-base')) {
      dropdownUserPanel.classList.remove('drop-down-base')
    }
  }

  title = ['Reactivate your Pro', 'subscription']
  subTitle = ['Access our full suite of strategy tools - take the next', 'step and unlock Pro.']
  content = [
    {
      title: 'Apply for any scholarship',
      text: 'You can start applying for scholarships with requirements again.'
    },
    {
      title: 'Customized recommendations',
      text: 'Apply for scholarships recommended for your profile and interests. '
    },
    {
      title: 'Similar scholarships',
      text: 'Repurpose your essays to apply for similar scholarships, AI-generated based on your previous applications.'
    },
    {
      title: 'Number of applicants',
      text: 'Boost your chances by applying to scholarships with fewer applicants.'
    },
    {
      title: 'Scholarship credibility scores',
      text: 'Focus your time and energy on highly rated scholarships.'
    },
    {
      title: 'Magic sorting',
      text: 'Now you can let our platform work its magic again.'
    }
  ]

  leftBtnStyles = {
    padding: this.isMob ? '0 5px' : '0 14px',
    height: '60px',
    width: '250px',
    borderRadius: '12px !important'
  }

  pending = false

  get isMob() {
    return this.$accessor.screen.resolution < 768
  }

  get minWidth() {
    return this.isMob ? '375px' : '855px'
  }

  get membership() {
    return this.$accessor.account.membership
  }

  mixpanelTrack(event) {
    const props = this.$route.params.cardId
      ? this.$mixpanel.fillProps(event, { scholarshipId: Number(this.$route.params.cardId) })
      : this.$mixpanel.fillProps(event)

    if (this.openedFrom) {
      props[this.$mixpanel.props.OPENED_FROM] = this.openedFrom
    }

    this.$mixpanel.track(event, props)
  }

  reactivatePlan() {
    if (this.pending) { return }
    this.pending = true

    this.mixpanelTrack(this.$mixpanel.events.REACTIVATE_PRO_PLAN_CLICK)

    this.$accessor.account.toggleMaintenanceMode({ isMaintenanceMode: 0 })
      .then(() => {
        this.$emit('close')
        setTimeout(() => this.$modal.show(
          Vue.component('SuccessReactivateModal'),
          {
            modalName: 'reactivate-success',
            subscriptionName: this.membership.name,
            packagePrice: this.membership.packagePrice,
            renewalDate: this.membership.renewalDate
          }), 400)
      })
      .catch(() => (this.pending = false))
  }
}
